const PeopleData = [
  {
    id: 1,
    name: "Montessori",
    text: "Me gustaría agradecer al sitio, me ayudó de una manera inimaginable, el psicólogo fue sumamente servicial y acogedor conmigo y me siento mejor conmigo mismo.",
  },
  {
    id: 2,
    name: "Gallardo",
    text: "Me gustaría agradecer a la página, me ayudó de una manera inimaginable, el psicólogo fue sumamente servicial y acogedor conmigo y me siento mejor conmigo mismo.",
  },
  {
    id: 3,
    name: "Lautaro",
    text: "Me gustaría agradecer a la web, me ayudó de una manera inimaginable, el psicólogo fue sumamente servicial y acogedor conmigo y me siento mejor conmigo mismo.",
  },
];

export default PeopleData;
